<div class="c-editor">
  <blockquote [innerHtml]="component.content.html">
  </blockquote>
</div>
